"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidInputType = void 0;
function isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || cardNumber instanceof String;
}
exports.isValidInputType = isValidInputType;



/*****************
 ** WEBPACK FOOTER
 ** ./~/credit-card-type/dist/lib/is-valid-input-type.js
 ** module id = 881
 ** module chunks = 0
 **/